import styled from 'styled-components';
import {
  Input,
  SearchBarView,
} from '../../common/components/SearchHeader/SearchBar/SearchBar.styles';
import { Container } from '../../common/components/SearchHeader/Suggestions/EmptySearchSuggestions/EmptySearchSuggestions.styles';
import { Item } from '../../common/components/SearchHeader/Suggestions/SuggestionList/SuggestionListItem/SuggestionListItem.styles';
import {
  ButtonBarView,
  Tab,
} from '../../common/components/SearchHeader/Suggestions/SuggestionsContainer/ButtonBar/ButtonBar.styles';
import {
  FloatingContainer,
  RelativeOffset,
} from '../../common/components/SearchHeader/Suggestions/SuggestionsContainer/SuggestionsContainer.styles';
import {
  ButtonBarContainer,
  SuggestionLayoutView,
} from '../../common/components/SearchHeader/Suggestions/SuggestionsLayoutTemplate/SuggestionsLayoutTemplate.styles';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { Breakpoint } from '../../common/styles/constants';

export const InlineSearchContainer = styled.div<{ experiment?: boolean }>`
  margin-bottom: ${props => (props.experiment ? '6px' : '0')};
  margin-top: ${props => (props.experiment ? '18px' : '32px')};
  position: relative;

  ${Breakpoint.SMALL} {
    margin-top: ${props => (props.experiment ? '40px' : '32px')};
  }

  ${SearchBarView} {
    display: none;
    width: 100%;

    ${Breakpoint.SMALL} {
      display: initial;
    }

    ${Input} {
      background-color: ${ThemeColours.white};
    }
  }

  ${ButtonBarContainer} {
    min-height: auto;

    ${ButtonBarView} {
      padding-left: 0;
      padding-right: 0;

      ${Tab} {
        padding: 16px 16px 12px;
      }
    }
  }

  ${SuggestionLayoutView} {
    min-height: auto;
  }

  ${RelativeOffset} {
    display: none;
    top: 100%;

    ${Breakpoint.SMALL} {
      display: initial;
    }

    ${FloatingContainer} {
      border-radius: 8px;
      box-shadow: 0px 15px 20px -10px rgb(0 0 0 / 8%);
      margin-top: 8px;
      max-height: calc(100vh - 524px);
      padding-left: 0;
      padding-right: 0;

      ${Item} {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }

  ${Container} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
